<div class="menu-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">
                        <img class="icon" src="assets/images/menu/svg/combo.svg"><span class="title">Combo</span>
                </div>
                <div class="page-actions">
                        @if(permission.can_add){
                        <button mat-button color="primary" class="btn-add"
                                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
                        }
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button>
                        }
                </div>
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>
                <app-search-filter *ngIf="isFilterReady" #searchFilter [pagingData]="pagingData"
                        [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter" (page)="onePageEvent($event)"
                        (onApply)="onFilterApplied($event)" [hidePageSize]="true">
                </app-search-filter>
                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                                                class="item-header">#</th>
                                        <td mat-cell *matCellDef="let menu; let i = index" class="item-column">{{
                                                (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                                </ng-container>
                                <ng-container matColumnDef="code">
                                        <th mat-sort-header="code" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)">Code</th>
                                        <td mat-cell *matCellDef="let combo">{{ combo.code }}</td>
                                </ng-container>
                                <ng-container matColumnDef="name">
                                        <th mat-sort-header="name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)">Name</th>
                                        <td mat-cell *matCellDef="let combo">{{ combo.name }}</td>
                                </ng-container>
                                <ng-container matColumnDef="display_name">
                                        <th mat-sort-header="display_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)">Display Name</th>
                                        <td mat-cell *matCellDef="let combo">{{ combo.display_name }}</td>
                                </ng-container>
                                <ng-container matColumnDef="value_name">
                                        <th mat-sort-header="value_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)">Values</th>
                                        <td mat-cell *matCellDef="let combo">{{ combo.value_name }}</td>
                                </ng-container>
                                <ng-container matColumnDef="action" stickyEnd>
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                                                <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                                                        (click)="onRowSelected(rowItem);$event.stopPropagation();">
                                                        <mat-icon>more_vert</mat-icon>
                                                </a>

                                                <mat-menu #rowMenu>
                                                        @if(permission.can_delete){
                                                        <button mat-menu-item
                                                                (click)="onDelete(rowItem)">Delete</button>
                                                        }
                                                        @if(permission.can_edit){
                                                        <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                                                        }
                                                        @else{
                                                        <button mat-menu-item (click)="onEdit(rowItem)">View</button>

                                                        }
                                                        <button mat-menu-item
                                                                (click)="onDuplicate(rowItem)">Duplicate</button>
                                                </mat-menu>
                                        </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row" *matRowDef="let combo; columns: displayedColumns;"
                                        (click)="onRowSelected(combo)" (dblclick)="onEdit(combo)"
                                        [ngClass]=" {'row-selected' : combo.id===selectedItem?.id}">
                                </tr>
                        </table>
                </section>
        </div>
</div>